export default class ResponsiveTable {
    static init(): void {
        const contentElements = document.querySelectorAll('.content');

        if (contentElements.length > 0) {
            contentElements.forEach(content => {
                const tables = content.querySelectorAll('table');
                if (tables.length > 0) {
                    tables.forEach(table => {
                        if (table.parentNode) {
                            const wrapper = document.createElement('div');
                            wrapper.className = 'content-table';
                            table.parentNode.insertBefore(wrapper, table);
                            wrapper.appendChild(table);
                        }
                    });
                }
            });
        }
    }
}